/**
 * Copyright 2026 Bluecircle Technologies Pvt Limited. All rights reserved.
 *
 * This software and its source code are the proprietary and confidential
 * intellectual property of Bluecircle Technologies Pvt Limited. Unauthorized
 * copying, reproduction, distribution, modification, public display, or use
 * of this software, in whole or in part, is strictly prohibited without the
 * prior written permission of Bluecircle Technologies Pvt Limited.
 */

/**
 * Who sees the create items in the top bar's menus (openspec create-from-topbar-menus).
 */

import * as roles from "app/common/roles";

/** Create workspace… in the workspace menu: owners of the current org only. */
export function showCreateWorkspace(orgAccess: string | null): boolean {
  return roles.canEditAccess(orgAccess);
}

/** Create organisation… in the org menu: exactly when the site switcher offers "Create new team site". */
export function showCreateOrg(opts: { createSiteEnabled: boolean, installAdmin: boolean, orgAdmin: boolean }): boolean {
  return opts.createSiteEnabled && (opts.installAdmin || opts.orgAdmin);
}
